import { TraderBalance } from "@components/balance";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { FlexLoader } from "@components/loader";
import { Operations } from "@components/operations";
import { TopUpBalanceModal } from "@components/top-up-balance-modal";
import { TransferMoneyModal } from "@components/transfer-money-modal";
import { Disputes } from "@features/appeals/components/disputes/trader";
import { useBalance } from "@features/balance";
import { balanceIsValid } from "@features/balance/helpers";
import { formatUsdt } from "@helpers/format";
import { useBoolState } from "@hooks/use-bool-state";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./finance.module.scss";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const FinancePage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  const [selectedPayType, setSelectedPayType] = useState<"payOut" | "payIn">();
  const resetSelectedPayType = useCallback(() => {
    setSelectedPayType(undefined);
  }, []);

  const navigate = useNavigate();

  const { state, getBalances, getSaveFrozenBalance } = useBalance();
  const { lastMessage } = useWebSocket();

  const websocketTypesToUpdateBalance = [
    WebsocketUpdateType.Balance,
    WebsocketUpdateType.Withdrawal,
    WebsocketUpdateType.Appeal,
    WebsocketUpdateType.Order,
    WebsocketUpdateType.PayOut,
  ];

  useEffect(() => {
    if (
      lastMessage &&
      websocketTypesToUpdateBalance.includes(lastMessage.type)
    ) {
      getBalances();
      getSaveFrozenBalance();
    }
  }, [lastMessage]);
  useEffect(() => {
    getBalances();
    getSaveFrozenBalance();
  }, []);

  if (!balanceIsValid(state)) {
    return null;
  }

  return (
    <>
      <div className={styles.finance}>
        <div className={styles.cards}>
          {state.loading || state.loadingSave ? (
            <FlexLoader warpperClassName={styles.balanceCard} />
          ) : (
            <TraderBalance
              type="trusted"
              balance={state.trust}
              saveBalance={state.save}
              onClick={showModal}
              className={styles.balanceCard}
            />
          )}
          {state.loading || state.loadingSave ? (
            <FlexLoader warpperClassName={styles.balanceCard} />
          ) : (
            <TraderBalance
              type="frozen"
              balance={state.frozen}
              onClick={() => {
                navigate("disputes");
              }}
              className={styles.balanceCard}
            />
          )}
          <Block className={styles.card}>
            <Profit
              className={styles.profitTransactions}
              title={"Прибыль с выводов"}
              value={state.payOut}
              onClick={() => setSelectedPayType("payOut")}
            />
            <Profit
              title={"Прибыль со сделок"}
              value={state.payIn}
              onClick={() => setSelectedPayType("payIn")}
            />
          </Block>
        </div>
        <Disputes />
        <Operations />
      </div>
      <TopUpBalanceModal isOpen={isModalOpen} hide={hideModal} />
      <TransferMoneyModal type={selectedPayType} hide={resetSelectedPayType} />
    </>
  );
};

type ProfitProps = {
  title: string;
  value: number;
  onClick: () => void;
  className?: string;
};

const Profit = ({ title, value, onClick, className }: ProfitProps) => {
  return (
    <div className={classNames(styles.profit, className)}>
      <div className={styles.left}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.balance}>{formatUsdt(value)}</p>
      </div>

      <Button disabled={!value} onClick={onClick} className={styles.button}>
        Вывести
      </Button>
    </div>
  );
};
